import { useTranslation } from 'react-i18next'
import SectionTitle from 'components/SectionTitle'
import { interacLogo, pixLogo } from 'resources/images'
import {
	ETransferContainer,
	ETransferIcon,
	GiftsWrapper,
	SectionContent,
} from './styles'

function Gifts() {
	const { t } = useTranslation()

	return (
		<GiftsWrapper id="gifts">
			<SectionTitle>{t('Presentes')}</SectionTitle>

			<SectionContent>
				<p>
					{t('giftContent')} <i className="fa-regular fa-heart" /> ♥
				</p>

				<div className="row">
					<ETransferContainer className="col-xs-12 col-sm-6">
						<ETransferIcon src={pixLogo} title="PIX 🇧🇷" />
						{t('Chave PIX')}: <strong>me@eltonviana.com</strong>
					</ETransferContainer>

					<ETransferContainer className="col-xs-12 col-sm-6">
						<ETransferIcon src={interacLogo} title="Interac 🇨🇦" />
						E-mail: <strong>thaisflins@gmail.com</strong>
					</ETransferContainer>
				</div>
			</SectionContent>
		</GiftsWrapper>
	)
}

export default Gifts
